/* eslint-disable */
import * as React from "react";

import cn from "classnames";
import { Typography } from "@material-ui/core";
import { MessageDescriptor, useIntl } from "react-intl";
import { createStyles } from "@material-ui/styles";
import { Theme, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(1),
    },
    horizontal: {
      flexDirection: "row",
      gap: theme.spacing(3),
    },
    label: {
      color: "#65ac1f",
      textTransform: "uppercase",
      fontSize: "14px",
      fontWeight: "bold",
      lineHeight: "17px",
    },
    title: {
      color: theme.palette.common.black,
      fontSize: "14px",
      lineHeight: "17px",
      fontWeight: "bold",
      opacity: 0.75,
    },
  })
);

type SubscriptionsSettingsSectionProps = {
  label: MessageDescriptor;
  children: React.ReactNode;
  horizontal?: boolean;
  className?: string;
};

export const SubscriptionsSettingsSection: React.FC<SubscriptionsSettingsSectionProps> = (props: SubscriptionsSettingsSectionProps) => {
  const { label, children, horizontal = false, className } = props;
  const { formatMessage } = useIntl();
  const classes = useStyles();

  if (!children) {
    return null;
  }
  let content = children;
  if (typeof children === "string") {
    content = <Typography className={classes.title}>{children}</Typography>;
  }

  return (
    <div className={cn(classes.root, { [classes.horizontal]: horizontal }, className)}>
      <Typography className={classes.label}>{formatMessage(label)}</Typography>
      {content}
    </div>
  );
};
